export default __webpack_public_path__ + "static/media/time-line-bottom.73c0cfac.svg";